import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'

import OrderItem from 'components/cart/OrderItem/OrderItem'

import whiteCaseImage from './images/whitecase.png'
import blackCaseImage from './images/blackcase.png'


const Subscription = ({ gender, subscription, price }) => {
  const productImage = gender === 'male' ? blackCaseImage : whiteCaseImage

  const data = {
    ...subscription,
    image: productImage,
  }

  if (price) {
    data.price = price
  }

  return (
    <OrderItem
      data={data}
      onRemove={({ id }) => actions.models.cart.removeSubscription(id)}
    />
  )
}

Subscription.propTypes = {
  price: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  gender: PropTypes.string,
  subscription: PropTypes.object,
}

export default connect({
  gender: 'models.me.gender',
  subscription: 'models.cart.items.subscription',
})(Subscription)
